export type SortableByPosition = { position: number | null }

export const sortByPosition = (
  a: SortableByPosition,
  b: SortableByPosition
): number => {
  if (a.position === null && b.position === null) return 0
  if (a.position === null) return 1
  if (b.position === null) return -1
  return a.position - b.position
}
